import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CavernicolAppLogo from '../../components/brand/CavernicolAppLogo';
import './LegalPageLayout.css';

export default function LegalPageLayout({ title, updatedAt, children, description }) {
  return (
    <div className="legal-page">
      <title>{`${title} — CavernicolApp`}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="noindex, follow" />
      <header className="legal-page__nav">
        <Link to="/landing" aria-label="CavernicolApp, ir al inicio"><CavernicolAppLogo /></Link>
        <Link to="/landing" className="legal-page__back"><ArrowLeft />Volver al inicio</Link>
      </header>
      <main className="legal-page__body">
        <article>
          <span className="section-kicker">DOCUMENTO LEGAL</span>
          <h1>{title}</h1>
          <p className="legal-page__updated">Última actualización: {updatedAt}</p>
          {children}
        </article>
      </main>
      <footer className="legal-page__footer">
        <CavernicolAppLogo inverse compact />
        <p>Un producto tecnológico de <a href="https://www.cavernicolacreativo.com/" target="_blank" rel="noreferrer">Cavernícola Creativo</a>.</p>
        <div>
          <a href="mailto:contacto@cavernicolacreativo.com">Contacto</a>
          <Link to="/terminos">Términos</Link>
          <Link to="/privacidad">Privacidad</Link>
          <Link to="/login">Acceso</Link>
        </div>
        <small>© 2026 Dragon Technologies SAPI de CV</small>
      </footer>
    </div>
  );
}
